import React from 'react'
import {
  motion,
  useScroll,
  useVelocity,
  useSpring,
  useTransform,
  useReducedMotion,
} from 'framer-motion'

const items = [
  'React ', 'Next JS', 'Node JS', 'TypeScript', 'Tailwind CSS', 'Framer Motion',
  'MongoDB', 'Express JS','PostgreSQL', 'Nest.js', 'Git', 'JavaScript',
  'Docker', 'GitHub Actions CI/CD', 'Nginx', 'Linux VPS Hosting', 'PM2',
]

export const Marquee = () => {
  const row = [...items, ...items]
  const reduce = useReducedMotion()

  // Lean the band into the scroll direction — the faster you scroll, the more
  // it skews, then it springs back to upright when you stop.
  const { scrollY } = useScroll()
  const velocity = useVelocity(scrollY)
  const smooth = useSpring(velocity, { stiffness: 260, damping: 45, mass: 0.4 })
  const skewX = useTransform(smooth, [-2500, 0, 2500], [6, 0, -6], { clamp: true })

  return (
    <section className=' bg-panel text-paper py-6 overflow-hidden marquee-mask select-none border-y border-paper/10'>
      <motion.div style={reduce ? undefined : { skewX }}>
        <div className=' marquee-track'>
          {row.map((s, i) => (
            <span key={i} className=' flex items-center gap-8 px-8 font-display text-3xl md:text-5xl font-medium tracking-tight'>
              {s}
              <span className=' text-mint text-2xl md:text-3xl'>✦</span>
            </span>
          ))}
        </div>
      </motion.div>
    </section>
  )
}
